export const DEFAULT_ENVIRONMENT_ID = 'defaultEnvironmentId';
